import { baseApi, providesList } from '@/shared/api'
import { DEFAULT_PAGE_SIZE } from '@/shared/lib'
import type { CommandAccepted, CommandListResponse, CommandsQuery } from '../model/types'

export const commandApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Команды текущего логина: что запущено, что в очереди и чем кончилось. Итоги `summary`
     * считает бэк. Постановка резерва, выпуск счёта и выгрузки инвалидируют `Command/LIST`
     * сами (их мутации), ход выполнения приходит опросом монитора — до WS-события
     * `command.updated` (`BE-14`).
     */
    getCommands: build.query<CommandListResponse, CommandsQuery>({
      query: ({ page = 1, pageSize = DEFAULT_PAGE_SIZE }) => ({
        url: '/commands',
        params: { page, pageSize },
      }),
      providesTags: (res) => providesList(res?.items, 'Command'),
    }),

    /** Отмена идущей команды. `409` — 1С уже ответила, отменять нечего: список перечитывается. */
    cancelCommand: build.mutation<void, string>({
      query: (id) => ({ url: `/commands/${encodeURIComponent(id)}/cancel`, method: 'POST' }),
      invalidatesTags: [{ type: 'Command', id: 'LIST' }],
    }),

    /** Повтор сорвавшейся команды: бэк ставит новую в очередь. */
    retryCommand: build.mutation<CommandAccepted, string>({
      query: (id) => ({ url: `/commands/${encodeURIComponent(id)}/retry`, method: 'POST' }),
      invalidatesTags: [{ type: 'Command', id: 'LIST' }],
    }),

    /** «Проверить сейчас» для команды в очереди с автоповтором: запуск вне расписания. */
    runCommand: build.mutation<CommandAccepted, string>({
      query: (id) => ({ url: `/commands/${encodeURIComponent(id)}/run`, method: 'POST' }),
      invalidatesTags: [{ type: 'Command', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetCommandsQuery,
  useCancelCommandMutation,
  useRetryCommandMutation,
  useRunCommandMutation,
} = commandApi
